import { ToothDataEntry, ToothSurfaceDataType } from '../teethData';
import { ToothView } from '../../../Enums/ToothView.enum';
import { ToothSurface } from '../../../../../graphql/graphql';

export const Tooth65: ToothDataEntry = {
	[ToothView.INCISAL]: {
		surfaces: {
			[ToothSurface.MesioBuccalCusp]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M11.2,63s31.2,21.8,39.2,21.4,19.8-15.2,34.7-15.2,25.3,3.8,25.3,3.8c0,0,11.4-27.2-7.6-42.8l-10.9-.2-6.4-1.1-12.6-4.5h-13.7l-12.2,3.8-10.7,4.5-7.9,4.9-6.8,7-6.6,7.5-3.8,10.7v.2Z',
			},
			[ToothSurface.DistoBuccalCusp]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M102.8,30.3h6.8l10.2,2.8,8.3,1.5,7.9,3.8,8.1,3.6,9,5.1,4.1,3.8,2.8,4.5,4.2,9.9s-18.1,20.7-26,18.7-10.1-6.5-27.8-11c0,0,11-26-7.6-42.8h0Z',
			},
			[ToothSurface.MesioPalatalCusp]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M19.5,137.1l6.3,9,6.8,15.3,6.6,10.8,8.2,6.4,15,6.3,6.1,1.4,14.8-.2,11.5-2.8,12.3-.7,10.4.3s-31.3-17,3.4-47c0,0-27.5,6.6-42.3,1.7s-22.8-14.2-28.7-14.7-30.3,14.1-30.3,14.1h-.1Z',
			},
			[ToothSurface.DistoPalatalCusp]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M120.7,136s13.2-9.2,22.8-9.2,34.2,10.9,34.2,10.9l-1,8.9-4.9,12.7-5,8.7-3.8,4.3-4.9,4.2-8.3,3.5-9.6,1.7-9.9,1.4h-12.9s-31.7-17.5,3.4-47h-.1Z',
			},
			[ToothSurface.Mesial]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M11.2,63l27.9,17.2s7.3,21.4.7,46c0,0-21.8,12.7-20.2,11l-3.8-6.3-3-9.5-2.7-10.1-1.8-10.5-.2-18.3,1.4-10.4,1.8-9h0Z',
			},
			[ToothSurface.Distal]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M164.2,65.4l3.4,8.3,2.2,10.6,2,11.2,1.2,10.2,2.5,12.4.9,10.2,1.3,9.4-25.2-9.3s-9.1-24.1-4.8-47.8l16.5-15.2h0Z',
			},
			[ToothSurface.Occlusal]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M39,80.2s7.6,4.2,11.3,4.2c9.8,0,18.9-15.6,34.7-15.2,34.8.9,47.9,14.8,53,14.8s9.5-3.4,9.5-3.4c0,0-4.3,21.1,4.8,47.8,0,0-12-5.4-31.8,7.6-12.3,8.1-30.5,5-42.3,1.7-16.8-4.6-23.1-14.7-28.7-14.7s-10,3.1-10,3.1c0,0,6.9-18.3-.7-46h.2Z',
			},
			[ToothSurface.Crown]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M148.1,179.6c-11,2.1-22.1,3.7-33.1,3-9.7-.6-18.7-.4-28.1,2.1s-22.3.7-32.9-3.4-14.2-7.2-18.5-14.8-6.7-12-9.4-18.5l-10-17c-8.9-23.4-9.9-48.1-3.5-72.3,1.6-6,7-10.6,10.8-14.9,7.2-8.1,16.3-12.7,26.7-15.4,8-2.1,16.9-4.9,25-2,9.4,3.3,18,3.9,27.9,4.2,18.3.6,35.6,7.8,50.5,17.9,4.8,3.2,6.5,8.4,8.8,13.3,4.6,9.8,7,19.6,8.7,30.3l3.9,25.6,2.2,16.1c1.9,13.7-9.2,42.3-29.2,46Z',
			},
		},
	},
	[ToothView.PALATAL]: {
		surfaces: {
			[ToothSurface.Mesial]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M30.7,123.4l-2.7-16.8-2.5-8,.4-12.7,3.6-11.2,4.1-6.4,4.3-1.9,6.9-7.2,9.6-6.5v61.3s-.4,9.4-9.6,9.4-14.1-.2-14.1-.2Z',
			},
			[ToothSurface.Distal]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M160.6,120.9l8-21.7v-12.2l-7.4-14.1-8.6-10.1-8.1-7.2-3.9-1.2-8-.2v53.8s-2.1,11.9,10.7,12.3,17.3.5,17.3.5Z',
			},
			[ToothSurface.Palatal]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M94.1,115.6A9.7,9.7 0 0 1 113.5,115.6A9.7,9.7 0 0 1 94.1,115.6Z',
			},
			[ToothSurface.CervicalPalatal]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M35,138.9s59,26.8,117.4,0l-6.4,11.3s-39.1,21.7-107.5-.7l-3.5-10.6Z',
			},
			[ToothSurface.MesioPalatalCusp]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M96.3,150.8s-29.9,1.4-61.3-11.9l-4.3-15.5-2.7-16.8-2.5-8,.4-12.7,3.6-11.2,4.1-6.4,4.3-1.9,6.9-7.2,9.6-6.5,4.4-1.4,6-1h8.8l6.5,1.5,6.5,3,9.4,5.4,8.8,7.9c0,35.5.5,49.4-8.4,82.5Z',
			},
			[ToothSurface.DistoPalatalCusp]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M104.8,68.3l8.4-5.6,7.4-3.4,12.1-5,8,.2,3.9,1.2,8.1,7.2,8.4,9.8,7.6,14.4v12.2l-8,21.7-8.2,18s-26.9,13.1-56.1,11.9c0,0,9.1-27,8.4-82.5Z',
			},
			[ToothSurface.Crown]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M155.7,131.5c-37.6,26.8-83.7,24.6-122,1-4.1-8.7-3.8-17.8-6.1-26.8s-3-24.2,4.7-34.7c1.3-1.7,3.7-2.8,5.3-4.5,5.6-5.8,11.5-11.6,19.4-14.2,17.6-5.7,34.2,2.7,47.2,15.9,10.5-7.4,22.2-12,34.6-14.6,10.2,4.1,17.8,12,23.3,21.4,4.3,6.4,7.6,14.3,5.8,22.1-2.7,12-7.2,22.5-12.2,34.4Z',
			},
		},
	},
	[ToothView.BUCCAL]: {
		surfaces: {
			[ToothSurface.Buccal]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M82.2,398.7A12.6,12.6 0 0 1 107.4,398.7A12.6,12.6 0 0 1 82.2,398.7Z',
			},
			[ToothSurface.Mesial]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M58.5,475.9h-4.8l-10.2-4.1-8.7-7.4h-3.4l-14.4-15.9v-8.8l1.8-8.3,4.3-15.6,5.9-19.1s29.5-7.7,29.5,24.7v54.4Z',
			},
			[ToothSurface.Distal]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M160.1,391.5l6.5,12.7,1.1,5.1v18.7l-1.8,8-10.2,13.6-4.8,4.8-5.1,6-6.7,4.9-3.9,1.6h-3.5l-2.5-1.2v-46.8s-.1-27.3,30.8-27.3Z',
			},
			[ToothSurface.CervicalBuccal]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M41.2,364.3s33.9-30.5,97.4-5.2v-7.1s-55.2-31.3-97.4,4.4v7.9Z',
			},
			[ToothSurface.MesioBuccalCusp]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M41.2,364.3l-5.3,11.6-5,13.7-1.8,7.1-5.9,19.1-4.3,15.6-1.8,8.3v8.8l14.4,15.9h3.4l8.7,7.4,10.2,4.1h4.8l9.7-4.2,7.1-.2,28.2-15.8s3.7-82.3-18.6-106.4c0,0-23.4,0-43.7,15.1Z',
			},
			[ToothSurface.DistoBuccalCusp]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M138.5,359.1l12.7,18.4,8.8,13.9,6.5,12.7,1.1,5.1v18.7l-1.8,8-10.2,13.6-4.8,4.8-5.1,6-6.7,4.9-3.9,1.6h-3.5l-2.5-1.2-5.4-1.8-12.7-5.6-5-3.5-2.7.9s4-72.5-18.6-106.4c0,0,21.6-2.6,53.6,9.9Z',
			},
			[ToothSurface.Crown]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M105.1,454.5c-13.4,8.8-21.8,14.6-37.5,17.3s-12.3,11.1-32.3-7.2c-5.4-1-9.1-4.6-11.7-9.2-5.1-3.3-7.4-8.4-6.3-14.4,1.6-9.5,4.5-18.3,7.2-27.6s6.9-24.8,11.6-37.6c16.9-11.4,35.3-20,56-22.5,17.8-2.2,37.3.6,50.6,12.9,6.5,5.9,10.5,14.3,15.5,21.5,9.3,13.4,12.5,30.5,7.5,45.9-2.6,8-8.5,13-14,19.1s-9.5,13-16.5,13.2c-10.8-.6-20.1-7.1-30-11.4Z',
			},
		},
	},
};
